<template>
  <div>
    <header class="header b-blue">
      <div class="container py-5" v-if="!downloading">
        <div class="row">
          <b-breadcrumb :items="items" class="bg-transparent ml-3 p-0"></b-breadcrumb>
          <div class="col-md-12 col-sm-12">
            <h3>Cursos para tu perfil</h3>
            <p>Tenemos cursos que se adaptan a tu perfil.</p>
          </div>
        </div>
      </div>
    </header>
    <section class="jobs-recomendation">
      <div class="container" v-if="downloading">
        <div class="container text-center py-5 font-gray-dark">
          <b-spinner v-if="downloading" label="Espere ..."></b-spinner>
          <br />Espere un momento...
        </div>
      </div>
      <div class="container" v-if="!downloading">
        <div class="row my-5" v-if="cursesRecomendation.length > 0">
<!--          <CurseMini-->
<!--            v-for="curse in cursesRecomendation"-->
<!--            :curse="curse"-->
<!--            :key="curse.id"-->
<!--            :cover="curse.cover"-->
<!--            :title="curse.title"-->
<!--            :description="curse.description"-->
<!--            :rating="curse.rating"-->
<!--            :students="curse.students"-->
<!--            :name="curse.url_public"-->
<!--          />-->
          <CourseRecomendation v-for="curso in cursesRecomendation" :key="curso.id" :curso="curso"/>
        </div>
        <div class="row py-5" v-else>
          <div class="col-lg-12 text-center font-gray-dark">
            <h1 class="font-weight-bold">¡Ups!</h1>
            <h5>No se han encontrado cursos recomendados</h5>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style lang="">
.header {
  padding-top: 5em;
  padding-bottom: 5em;
}
@media only screen and (max-width: 600px) {
  .header {
    text-align: center;
  }
}
</style>
<script>
// import CurseMini from "./components/home/CurseMini";
import CourseRecomendation from "./components/home/CourseRecomendation";

export default {
  components: {
    'CourseRecomendation': CourseRecomendation
  },
  data() {
    return {
      cursesRecomendation:{},
      downloading: false,
      items: [
        {
          text: "Cursos",
          href: "/cursos"
        },
        {
          text: "Recomendaciones",
          active: true
        }
      ],
    };
  },
  mounted() {
    this.recomendations()
  },
  methods: {
    recomendations(){

      this.downloading = true

      this.api.get('student/cv/profile/recomendations').then(({data}) => {

        if(data.data.curses.length){
          this.cursesRecomendation = data.data.curses
        }
          this.downloading = false
        // else{
        //   this.wantedJobs()
        // }

      }).catch(err => {
        this.downloading = false
      })

    },
    wantedJobs(){
      this.api.get(`wanted_courses`)
          .then(({data}) => {


            if(data.data.length){

              this.cursesRecomendation = data.data
              console.log(data.data)
              this.downloading = false

            }

          }).catch(e => { this.downloading = false })
    }

  }
  // computed: {
  //   cursesRecomendation: function() {
  //     return this.$store.getters.cursesRecomendation;
  //   }
  // },
};
</script>



// WEBPACK FOOTER //
// src/components/#public/curse/CursesRecomendation.vue